const emojis = {
  like: '&#x1F44D;',
  angry: '&#x1F620;',
  laugh: '&#x1F606;',
  surprised: '&#x1F62E;',
  heart: '&#x1F497;',
  sad: '&#x1F641;'
};

export const getEmojiByName = name => emojis?.[name] || name || '';